/**
 * Current list page, kept in the URL (``?page=3``) so it survives a
 * refresh and can be shared. Filter changes must ``next.delete("page")``.
 */
import axios from "axios";
import { useSearchParams } from "react-router-dom";

/** The server answers 404 for a page past the end. Page one always exists. */
export function isMissingPage(error: unknown, page: number): boolean {
  return page > 1 && axios.isAxiosError(error) && error.response?.status === 404;
}

/** Rows per page on every list: short enough to scan without much scrolling. */
export const LIST_PAGE_SIZE = 20;

export function usePageParam() {
  const [params, setParams] = useSearchParams();
  const raw = params.get("page") ?? "";
  const page = /^[1-9]\d*$/.test(raw) ? Number(raw) : 1;
  function setPage(next: number) {
    const nextParams = new URLSearchParams(params);
    if (next <= 1) nextParams.delete("page");
    else nextParams.set("page", String(next));
    setParams(nextParams, { replace: true });
  }
  return { page, setPage };
}
